module.exports = __webpack_public_path__ + "static/media/BIMpic7.e8758a2d.png";